import parseHumanFloat from '~/utils/Number/parseHumanFloat';

import isValidDosage from './isValidDosage';

export default function parseDosage(dosage: string | null): {
	value: number | null;
	isValid: boolean | null;
} {
	if (dosage === '' || dosage === null || dosage === undefined) {
		return { value: null, isValid: null };
	}
	const value = parseHumanFloat(dosage);
	const isValid = value !== null && isValidDosage(value);
	return { value: isValid ? value : null, isValid };
}
